<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="500" height="500" :show-footer="true" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" :loading="loading"
			:title="title">
			<template #default>
				<div class="full" style="position: relative;">
					<el-form ref="form" :model="form" label-width="50px">
						<el-form-item label="内容">
							<el-input type="textarea" :placeholder="title" v-model="form.content"></el-input>
						</el-form-item>
						<el-form-item label="附件">
							<upload v-model="form.img" :formCreateInject="true" />
						</el-form-item>
					</el-form>
				</div>
				<div v-if="percentShow" class="full flex"
					style="flex-direction: column;align-items: center;justify-content: center;background-color: rgba(255, 255, 255, 0.6);">
					<el-progress type="circle" :percentage="percentage"></el-progress>
				</div>
			</template>
			<template #footer>
				<vxe-button size="mini" status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>

	</div>
</template>
<style scoped>

</style>
<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return '发送信息'
				}
			},
			row: {
				default: () => {
					return []
				}
			}

		},
		data() {
			return {
				errordata: [],
				issend: 0,
				percentShow: false,
				percentage: 0,
				loading: false,
				model: false,
				handle: 0,
				form: {
					content: '',
					img: []
				}
			}
		},
		created() {

		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			alert() {
				this.model = true
			},
			close() {
				this.form = {
					content: '',
					img: []
				}
				this.model = false

			},
			show() {
				this.errordata = []
				this.issend = 0
				this.percentShow = false
				this.percentage = 0
			},
			hide() {
				clearInterval(this.handle)
			},
			submit() {
				if (this.percentShow) {
					this.$message.error('发送中...')
					return
				}
				this.percentShow = true
				//let promise = null
				// if (!this.form.content) {
				// 	this.$message.error('请填写内容')
				// 	return
				// }
				let contents = []
				this.row.forEach((rowitem) => {
					let data = {
						content: {}
					}
					data.roomid = rowitem.type == 'room' ? rowitem.id : rowitem.roomid
					data.memberid = rowitem.type == 'member' ? rowitem.id : null
					data.content.text = this.form.content
					//data.content.file = []
					data.content.file = this.form.img.map((item) => {
						return item.path
					})
					contents.push(data)
					
					
					// if (!promise) {
					// 	promise = this.send(data)
					// } else {
					// 	promise = promise.then(() => {
					// 		return this.send(data)
					// 	})
					// }
				})
				this.send(contents)
				
			},
			send(contents) {
				this.$api.wechaty.sendmessagetask({contents:contents}).then(()=>{
					this.sendover()
					this.$message.success('创建发送任务成功')
				})
				//console.log(contents)
			},
			// send(data,t=2000) {
			// 	console.log(data)
			// 	return
			// 	return new Promise((reslove) => {
			// 		fetch(window.config.wechaty + '/sendMessage', {
			// 				method: 'POST',
			// 				headers: {
			// 					'Content-Type': 'application/json'
			// 				},
			// 				body: JSON.stringify(data)
			// 			}).then((response) => response.text())
			// 			.then((e) => {
			// 				let res = JSON.parse(e)
			// 				if (res.code != 200) {
			// 					this.errordata.push(data.roomid)
			// 				}
			// 				setTimeout(() => {
			// 					this.issend++
			// 					this.percentage = parseFloat((this.issend / this.row.length * 100).toFixed(
			// 						2))
			// 					if (this.issend >= this.row.length) {
			// 						this.sendover()
			// 					}	
			// 					reslove()
			// 				},t)
			// 			})
			// 			.catch(() => {
			// 				this.errordata.push(data.roomid)
			// 				setTimeout(() => {
			// 					this.issend++
			// 					this.percentage = parseFloat((this.issend / this.row.length * 100).toFixed(
			// 						2))
			// 					if (this.issend >= this.row.length) {
			// 						this.sendover()
			// 					}
			// 					reslove()
			// 				}, t)
			// 			});
			// 	})
			// },


			sendover() {
				this.$emit('sendover', {
					errordata: this.errordata
				})
				this.percentage = 100
				setTimeout(() => {
					this.close()
				}, 1000)
			}
		},
		components: {
			upload
		}
	}
</script>